import React from 'react';

import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import { Container } from 'styles/admin';
import { FlexContainer, StyledBorderedPaper, VerticallyAlignedFlexContainer } from 'styles/common';

import { KH_LINKS_HELP_CENTER } from 'constants/knowledgeHubLinks';
import theme from 'constants/theme';

import { Typography11, Typography13, Typography16 } from 'uiToolkit/Typography';

const KHCard = ({ src, heading, subText, url }) => (
  <HoverContainer>
    <NonStyledAnchor target={`_${url}`} href={url}>
      <ColoredBorderedPaper style={{ padding: '1rem', height: '100%' }}>
        <FlexContainer
          style={{
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-evenly',
          }}
        >
          <Typography13 bottomGutter={2}>{heading}</Typography13>
          <Typography13 textalign="center">{subText}</Typography13>
        </FlexContainer>
      </ColoredBorderedPaper>
    </NonStyledAnchor>
  </HoverContainer>
);

const KnowledgeHub = () => (
  <Container>
    <VerticallyAlignedFlexContainer>
      <Typography16 bottomGutter={3}>Knowledge Hub</Typography16>
    </VerticallyAlignedFlexContainer>
    <StyledBorderedPaper style={{ padding: '2.5rem 1.5rem' }}>
      <Header>
        <Typography11 textalign="center">How can we help you?</Typography11>
      </Header>
      <Grid container>
        {KH_LINKS_HELP_CENTER.map(({ heading, subText, src, url }, idx) => (
          <Grid
            sm={idx === KH_LINKS_HELP_CENTER.length - 1 ? true : 4}
            key={idx}
            item
            style={{ marginBottom: '1.5rem', minHeight: '6rem' }}
          >
            <KHCard heading={heading} subText={subText} src={src} url={url} />
          </Grid>
        ))}
      </Grid>
    </StyledBorderedPaper>
  </Container>
);

const ColoredBorderedPaper = styled(StyledBorderedPaper)`
  border: 1px solid ${theme.palette.primary.main};
  color: ${theme.palette.primary.main};
  &:hover {
    background: ${theme.palette.primary.main};
    color: white;
  }
`;

const Header = styled.div`
  margin-bottom: 1.5rem;
`;
const StyledImg = styled.img`
  width: 4rem;
  height: 4rem;
  margin-bottom: 1.5rem;
`;
const NonStyledAnchor = styled.a`
  font-size: 0;
  text-decoration: none;
`;
const HoverContainer = styled.div`
  margin-right: 2.25rem;
  height: 100%;
`;

export default KnowledgeHub;
